import { api } from "@astro/api";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { appUrl } from "@astro/config";
import { currencyFormatter } from "./helper";
import { PiCrownDuotone } from "react-icons/pi";

export default function ConsultationHubSection() {

  const { data, isLoading } = useQuery({
    queryKey: ["astrologersList"],
    queryFn: () => api.astrologers.list({ page: 1, per_page: 4 }),
    placeholderData: keepPreviousData
  });

  /** crop astrologer data */
  const astrologers = (data?.data || []).slice(0, 4);


  return (
    <section className="py-16 px-6 md:px-16 pt-0 bg-white">
      <div className="container mx-auto max-w-350">
        <div className="relative overflow-hidden rounded-4xl bg-background p-8 md:p-12 border border-primary/5">
          <div className="grid lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-4 space-y-6">
              <div className="inline-flex items-center gap-3 px-4 py-2 bg-white rounded-full border border-primary/10 shadow-sm">
                <i className="fa-solid fa-comments text-secondary text-sm"></i>
                <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-primary/60">Expert Guidance</span>
              </div>
              <h3 className="font-heading text-3xl md:text-4xl text-primary leading-tight">Consult Our <br />Astrologers</h3>
              <p className="text-sm leading-relaxed text-primary/70">One-on-one sessions for accurate gemstone recommendations and spiritual remedies.</p>
              <a href={appUrl('jyotish', 'book-maharaj-ji')} className="inline-flex items-center justify-center py-3.5 px-8 rounded-xl bg-primary text-white font-bold uppercase tracking-widest text-[10px] hover:bg-secondary transition-all shadow-lg shadow-primary/20">Book session <i className="fa-solid fa-arrow-right ml-2 text-[10px]"></i></a>
            </div>

            <div className="lg:col-span-8">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <a href={appUrl('jyotish', 'maharaj-ji')} className="group relative col-span-2 row-span-2 rounded-2xl overflow-hidden shadow-lg h-64 md:h-full">
                  <img src="/images/maharaj-ji200.png" className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" alt="Raju Maharaj" />
                  <div className="absolute inset-0 bg-linear-to-t from-black/80 to-transparent"></div>
                  <div className="absolute top-5 left-5 text-[8px] bg-secondary text-primary px-2 py-0.5 rounded-md uppercase font-bold tracking-widest flex items-center gap-1">
                    <PiCrownDuotone size={16} />
                    <span className="">Master</span>
                  </div>
                  <div className="absolute bottom-5 left-5 text-white">
                    <h4 className="text-lg font-heading mt-1">Raju Maharaj</h4>
                  </div>
                </a>

                {isLoading ? (
                  Array.from({ length: 4 }).map((_, i) => (
                    <div key={i} className="bg-white p-3 rounded-2xl border border-gray-100 block animate-pulse">
                      <div className="h-48 bg-gray-200 rounded-xl mb-3"></div>
                      <div className="h-3 bg-gray-200 rounded w-3/4 mb-2"></div>
                      <div className="flex justify-between items-center">
                        <div className="h-2 bg-gray-200 rounded w-1/3"></div>
                        <div className="h-2 bg-gray-200 rounded w-1/4"></div>
                      </div>
                    </div>
                  ))
                ) : (
                  astrologers.map((e) => (
                    <a key={e.id} href={appUrl('jyotish', `astrologers/${e.id}`)} className="group bg-white p-3 rounded-2xl border border-gray-100 transition-all hover:shadow-lg block">
                      <div className="h-48 bg-gray-100 rounded-xl mb-3 overflow-hidden relative">
                        <img src={e?.image_url} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" alt={e?.name} />
                        {e?.experience && (
                          <div className="absolute bottom-2 right-2 z-10">
                            <span className="bg-secondary text-white px-2 py-1  text-[8px] font-bold tracking-widest uppercase shadow-sm rounded-full">
                              {e.experience}+ Yrs
                            </span>
                          </div>
                        )}
                      </div>
                      <h4 className="font-heading text-sm text-primary truncate">{e?.name}</h4>
                      {e?.skills?.length > 0 && <span className="text-xs text-gray-400 truncate">{e?.skills[0]}</span>}
                      <div className="flex justify-between items-center mt-1">
                        <span className="text-[10px] font-bold text-primary">{e?.rate ? currencyFormatter(e?.rate) : '...'}</span>
                        {e.rating && <span className="text-[9px] font-bold text-secondary">{e?.rating} ★</span>}
                      </div>
                    </a>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
